import { useRef } from "react";
import { keepHeaderMenuTriggerFocused } from "@/components/layout/headerButtonClassName";

interface HeaderMenuFocus {
  notePointerOpen: () => void;
  noteKeyboardOpen: () => void;
  keepTriggerFocused: (event: Event) => void;
}

/**
 * Remembers whether a header menu was opened with the pointer, so focus stays
 * on the trigger and the highlight does not flash.
 */
const useHeaderMenuFocus = (): HeaderMenuFocus => {
  const openedWithPointer = useRef(false);

  const notePointerOpen = () => {
    openedWithPointer.current = true;
  };

  const noteKeyboardOpen = () => {
    openedWithPointer.current = false;
  };

  const keepTriggerFocused = (event: Event) => {
    keepHeaderMenuTriggerFocused(openedWithPointer, event);
  };

  return { notePointerOpen, noteKeyboardOpen, keepTriggerFocused };
};

export { useHeaderMenuFocus };
